import {
  ActivityIcon,
  BarChartIcon,
  BellIcon,
  BlocksIcon,
  BotIcon,
  BoxIcon,
  BoxesIcon,
  CableIcon,
  CameraIcon,
  ChartNetworkIcon,
  CloudIcon,
  CodeIcon,
  ContainerIcon,
  CpuIcon,
  DatabaseIcon,
  DownloadIcon,
  EarthLockIcon,
  EyeIcon,
  FilmIcon,
  FolderIcon,
  GaugeIcon,
  GlobeIcon,
  HardDriveIcon,
  HomeIcon,
  KeyIcon,
  LineChartIcon,
  LockIcon,
  MailIcon,
  MonitorIcon,
  MusicIcon,
  NetworkIcon,
  PhoneIcon,
  PrinterIcon,
  PuzzleIcon,
  RadarIcon,
  RadioIcon,
  RouterIcon,
  RssIcon,
  SearchIcon,
  ServerIcon,
  SettingsIcon,
  ShieldCheckIcon,
  ShieldIcon,
  TerminalIcon,
  TimerIcon,
  UploadIcon,
  WebhookIcon,
  WifiIcon,
  ZapIcon
} from 'lucide-react-native'

//icons a plugin can request in plugin.json via "Icon", e.g. "Icon": "Database".
//kept as an explicit list so the bundle doesn't pull in all of lucide.
const PluginMenuIcons = {
  Activity: ActivityIcon,
  BarChart: BarChartIcon,
  Bell: BellIcon,
  Blocks: BlocksIcon,
  Bot: BotIcon,
  Box: BoxIcon,
  Boxes: BoxesIcon,
  Cable: CableIcon,
  Camera: CameraIcon,
  ChartNetwork: ChartNetworkIcon,
  Cloud: CloudIcon,
  Code: CodeIcon,
  Container: ContainerIcon,
  Cpu: CpuIcon,
  Database: DatabaseIcon,
  Download: DownloadIcon,
  EarthLock: EarthLockIcon,
  Eye: EyeIcon,
  Film: FilmIcon,
  Folder: FolderIcon,
  Gauge: GaugeIcon,
  Globe: GlobeIcon,
  HardDrive: HardDriveIcon,
  Home: HomeIcon,
  Key: KeyIcon,
  LineChart: LineChartIcon,
  Lock: LockIcon,
  Mail: MailIcon,
  Monitor: MonitorIcon,
  Music: MusicIcon,
  Network: NetworkIcon,
  Phone: PhoneIcon,
  Printer: PrinterIcon,
  Puzzle: PuzzleIcon,
  Radar: RadarIcon,
  Radio: RadioIcon,
  Router: RouterIcon,
  Rss: RssIcon,
  Search: SearchIcon,
  Server: ServerIcon,
  Settings: SettingsIcon,
  Shield: ShieldIcon,
  ShieldCheck: ShieldCheckIcon,
  Terminal: TerminalIcon,
  Timer: TimerIcon,
  Upload: UploadIcon,
  Webhook: WebhookIcon,
  Wifi: WifiIcon,
  Zap: ZapIcon
}

//accepts "Database", "DatabaseIcon" or "database"; unknown names fall back
export const pluginMenuIcon = (name) => {
  if (!name || typeof name != 'string') return PuzzleIcon
  const key = name.replace(/Icon$/, '')
  const match = Object.keys(PluginMenuIcons).find(
    (entry) => entry.toLowerCase() == key.toLowerCase()
  )
  return match ? PluginMenuIcons[match] : PuzzleIcon
}

export { PluginMenuIcons }
